import React, { useCallback, useEffect, useRef, useState } from 'react';
import Navbar from "../../../components/comm/Navbar";
import Header from "../../../components/comm/Head";
import style from './MyPageMain.module.css';
import EmptyContentBox from '../../../components/box/EmptyContentBox';
import MyDataSummary from './data/MyDataSummary';
import MyDataDetails from './data/MyDataDetails';


//Tab
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import URL from "../../../constants/url";
import { useLocation, useNavigate, useSearchParams} from 'react-router-dom';


const MyPageMain = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const isFirstRender = useRef(true);

    const [isLoading, setIsLoading] = useState(true);

    const [mediInfo, setMediInfo] = useState();
    const [srvrSyncDt, setSrvrSyncDt] = useState();

    // 탭
    const defaultTab = searchParams.get('tab') || '1';
    const [value, setValue] = useState(defaultTab);

    //병원 연결 바로가기
    const [empty, setEmpty]= useState();

    // 전체메뉴에서 상세보기 클릭시 탭2로 이동
    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam && tabParam !== value) {
        setValue(tabParam);
        }
    }, [searchParams]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchParams({ tab: newValue });
        navigate(newValue === '1' ? URL.MY_PAGE_SUMMARY : URL.MY_PAGE_DETAIL);
    };


    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            getUsrMediHlthInfo();
            return;
        }
    }, []);

    useEffect(() => {
        const path = location.pathname;
        if (path.endsWith('/summary')) {
            setValue('1');
        } else if (path.endsWith('/detail')) {
            setValue('2');
        } else {
            // 기본값: summary로 강제 이동
            //navigate(URL.MY_PAGE_SUMMARY, { replace: true });   // 전체메뉴에서 상세보기 클릭시 탭2 로 이동
        }
    }, [location.pathname]);


    const getUsrMediHlthInfo = useCallback(async () => {

        const url = "/mypage/retrieveUsrMediHlthInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
            , withCredentials: true
        }


        await axiosApi.post(url, {}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result.mediInfo;

                setMediInfo({...mediInfo});
                setSrvrSyncDt(res.data.result.srvrSyncDt);

                //한번도 등록 안한 사용자 === 페이지접근조차 안한..
                if(mediInfo.frstInptAt === '0') {
                    // setEmpty(true);
                    navigate(URL.MY_DATA_COLLECT, { state: { id: mediInfo.id } });
                } else {
                    setEmpty(false);
                    setIsLoading(false);
                }
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })

    }, [navigate]);

    if (isLoading) return null;

    return (
        <>
            <Header menu="mypage" />

            <div className='container' data-posi='fixed'>

                <TabContext value={value} className="tab-context">
                        <div className='top-tab-head' data-posi='fixed'>
                            <TabList
                                onChange={handleChange}
                                aria-label="lab API tabs example"
                                variant="scrollable"
                                scrollButtons={false}
                                className={style["tab-header"]}
                            >
                                <Tab label="요약 정보" value="1" disableRipple />
                                <Tab label="상세 정보" value="2" disableRipple />
                            </TabList>
                        </div>
                        <TabPanel value="1">

                            {empty === false &&
                                <MyDataSummary mediInfo={mediInfo} srvrSyncDt={srvrSyncDt}/>
                            }

                        </TabPanel>

                        <TabPanel value="2">

                            {empty === false &&

                                <MyDataDetails />
                            }

                        </TabPanel>

                    </TabContext>

            </div>

            <Navbar />
        </>
    )
}

export default MyPageMain
